import { TOGGLE_AUTH_MODAL } from './actionTypes'

export const toggleAuthModal = visible => async dispatch => {
  dispatch({ type: TOGGLE_AUTH_MODAL, visible })
}
